export default __webpack_public_path__ + "349f06ea7d4bbfe5760a8ef1e5b089ca.png";